/**
 * IMPORTANT: Do not use route() or localizedRoute() in this file as this breaks SSR.
 *
 * The ErrorPage is rendered without the HandleInertiaRequest middleware and therefore
 * Ziggy routes are not available.
 */

import { GuestLayout } from '@/Layouts';
import { useTranslation } from 'react-i18next';
import { Head } from '@inertiajs/react';

type ErrorPageProps = {
    status: number;
}

export default function({ status }: ErrorPageProps) {
    const { t } = useTranslation(['app']);

    return (
        <>
            <Head>
                <title>
                    {t(`errors.${status}.title`, { defaultValue: t('errors.default.title') })}
                </title>

                <meta
                    name={'description'}
                    content={t(`errors.${status}.message`, { defaultValue: t('errors.default.message') })} />

                <meta
                    name="robots"
                    content="noindex,nofollow" />
            </Head>

            <GuestLayout
                title={t(`errors.${status}.title`, { defaultValue: t('errors.default.title') })}
                description={t(`errors.${status}.message`, { defaultValue: t('errors.default.message') })} />
        </>
    );
}
